import URI from 'urijs';

export function getQueryVariable(variable: string, url = location.href): string|false
{
  if(URI(url).hasQuery(variable)) {
    return URI(url).search(true)[variable].toString() || false;
  } else {
    return false;
  }
  
}

export function updateQueryStringParameter(uri:string, key:string, value:string) {
  return URI(uri).setSearch(key, value).toString(); 
}